jQuery(document).ready(function () {
    $(document).on('click', '.dnJs-loadMore', function (e) {
        e.preventDefault();
        var button = $(this);
        var container = button.closest('.dnButtonLoadMore');
        var url = button.attr("href");
        var containerClass = button.attr('data-container-class');
        var dataRemoveElement = button.attr('data-remove-element');
        var dataRemove = button.attr('data-remove');

        button.addClass('dnButtonLoadMore-button-isLoading');

        $.ajax({
            type: "GET",
            url: url,
            success: function (response) {
                var response = $(response);

                var responseContainer = response.find(containerClass);

                if (dataRemove && dataRemoveElement) {
                    responseContainer.find('*[data-' + dataRemoveElement + '="' + dataRemove + '"]').remove();
                }

                var list = responseContainer.html();

                container.replaceWith(list);

                dnJsLazyload();

                if (typeof renderUnrenderedCharts !== "undefined") {
                    renderUnrenderedCharts();
                }
            }
        });
    });
});